import {
  PluginFindReplaceSchema_2023_08_20,
  PluginFindReplaceType_2023_08_20,
} from "./2023-08-20";

export const PluginFindReplaceSchema = PluginFindReplaceSchema_2023_08_20;
export type PluginFindReplaceType = PluginFindReplaceType_2023_08_20;
